import React from "react"
//import I18n from "i18n-js/index.js.erb"

class BackgroundColorInput extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // init background color plugin
    $(this.refs.input).spectrum({
      allowEmpty: true,
      preferredFormat: 'rgb',
      cancelText: I18n.t('form_cancel'),
      chooseText: I18n.t('form_submit'),
      showButtons: true,
      showInput: true,
      color:  this.props.initialValue,
      hide:   this._onStyleChange,
      move:   this._onStyleChange,
      change: this._onStyleChange
    });
    this._onStyleChange = this._onStyleChange.bind(this);
  }

  componentWillUnmount() {
    // destroy background color plugin
    $(this.refs.input).spectrum('destroy');
  }

  render() {
    return (
      <input type="text" ref="input" />
    );
  }

  _onStyleChange(color) {
    var color = (color == null || color._a == 0) ? 'transparent' : color.toRgbString();
    $(this.refs.input).spectrum('set', color);
    this.props.onStyleChange(PageBuilderConstants.BACKGROUND_COLOR, color);
  }

};

export default BackgroundColorInput
